<template>
  <Dropdown placement="bottom-end">
    <Button variant="action" :icon="languageIcon" />
    
    <template #menu>
      <DropdownMenu width="auto">
        <nav class="flex flex-col py-1 px-1">
          <DropdownMenuItem
            v-for="locale in availableLocales"
            :key="locale.key"
            as="button"
            size="small"
            class="flex items-center gap-2"
            :class="{ 'bg-primary-50 dark:bg-primary-900': currentLocale === locale.key }"
            @click="changeLanguage(locale.key)"
          >
            <span>{{ locale.name }}</span>
            <Icon 
              v-if="currentLocale === locale.key" 
              name="check" 
              type="micro" 
              class="mr-auto text-primary-500"
            />
          </DropdownMenuItem>
        </nav>
      </DropdownMenu>
    </template>
  </Dropdown>
</template>

<script>
import { Button, Icon } from 'laravel-nova-ui'
import { usePage } from '@inertiajs/inertia-vue3'

export default {
  components: {
    Button,
    Icon,
  },

  setup() {
    const page = usePage()
    return { page }
  },

  methods: {
    async changeLanguage(locale) {
      if (this.currentLocale === locale) {
        return
      }

      try {
        // Update user's language in database
        await Nova.request().post('/nova-api/locale', { locale })
        
        // Reload page to apply new locale and update currentUser
        window.location.reload()
      } catch (error) {
        Nova.error(this.__('Failed to change language. Please try again.'))
      }
    },
  },

  computed: {
    languageIcon() {
      return 'globe-alt'
    },

    availableLocales() {
      return this.page?.props?.value?.availableLocales || [
        { key: 'fa', name: 'فارسی' },
        { key: 'en', name: 'English' },
      ]
    },

    currentLocale() {
      return this.$store.getters.currentUser?.language || Nova.config('locale') || 'fa'
    },
  },
}
</script>

